// PROJECT DISCONTINUE

import React, { Component } from 'react';

import ic_cancel from '../resources/cancel_circle.png';

export default class BundleProductUpdateDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data : JSON.parse(this.props.data)
    }
  }

  formatCurrency(amount) {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  }

  render() {
    const { bundle_name, id_bundle, bundle_details } = this.state.data;

    return (
      <div onClick={(e) => this.props.onCloseListener('close', null)} className='process_dialog_root layer_a'>
        <div onClick={(e) => e.stopPropagation()} className='process_dialog_container' style={{width: 700, maxHeight: 500}}>
          <div className='title_search_container orange_background'>
            <div className='full_flex default_text_medium_white bold_text'>PRODUK BUNDLE - {bundle_name}</div>
            <img onClick={(e) => this.props.onCloseListener('close', null)} className='custom_cursor_a mini_image_c' src={ic_cancel} alt='' />
          </div>

          <div style={{padding: 15, overflow: 'auto', maxHeight: 400}}>
            {/* Bundle Info */}
            <div style={{marginBottom: 15}}>
              <div style={{display: 'flex', gap: 20}}>
                <div>
                  <span className='default_text_normal_gray bold_text'>ID Bundle: </span>
                  <span className='default_text_normal_gray'>{id_bundle}</span>
                </div>
              </div>
            </div>

            {/* Table Header */}
            <div style={{display: 'flex', backgroundColor: '#f0f0f0', padding: '10px 5px', fontWeight: 'bold', borderBottom: '1px solid #ccc'}}>
              <div style={{flex: 0.5, textAlign: 'center'}}>No</div>
              <div style={{flex: 1}}>Product ID</div>
              <div style={{flex: 1.5}}>Group Product</div>
              <div style={{flex: 1}}>Quantity</div>
              <div style={{flex: 1}}>Unit</div>
              <div style={{flex: 1.5, textAlign: 'right'}}>Price</div>
            </div>

            {/* Table Body */}
            {bundle_details && bundle_details.length > 0 ? (
              bundle_details.map((item, index) => (
                <div key={index} style={{display: 'flex', padding: '10px 5px', borderBottom: '1px solid #eee', alignItems: 'center'}}>
                  <div style={{flex: 0.5, textAlign: 'center'}}>{index + 1}</div>
                  <div style={{flex: 1}} className='default_text_normal_gray'>{item.product_id}</div>
                  <div style={{flex: 1.5}} className='default_text_normal_gray'>{item.group_product || '-'}</div>
                  <div style={{flex: 1}} className='default_text_normal_gray'>{item.quantity}</div>
                  <div style={{flex: 1}} className='default_text_normal_gray'>{item.unit || '-'}</div>
                  <div style={{flex: 1.5, textAlign: 'right'}} className='default_text_normal_gray'>{this.formatCurrency(item.price)}</div>
                </div>
              ))
            ) : (
              <div style={{padding: 20, textAlign: 'center', color: '#999'}}>
                Tidak ada produk dalam bundle ini
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

}